import React, { useEffect, useState, JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    Show,
    SelectArrayInput,
    List,
    TextField,
    NumberField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
    BooleanField,
    SelectField,
} from 'react-admin';


const ListActions = () => {
    return(
        <TopToolbar>
            {/* The minis were always ROLE_ADMIN and above on the API as well as here, so
                HQ_Nok::minis reproduces this gate exactly. */}
                <CreateButton />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}


export const NokMiniList: () => JSX.Element = (): JSX.Element => {
    const selectChoices: { id: string, name: string }[] = [
        { id: 'disabled', name: 'Disabled' },
        { id: 'invitation', name: 'Invitation' },
        { id: 'available', name: 'Available' },
    ];
    return (
        <List
            actions={<ListActions/>}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name"  />
                <SelectField source="status" choices={ selectChoices } />
                <EditButton />
            </Datagrid>
        </List>
    );
}
